import { useAction, useAtom } from '@reatom/npm-react'
import { motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, Close3Icon } from '@blade/ui-kit'
import { FadeOverflow } from '@root/shared/ui-kit'
import { HeaderBrand } from '@root/widgets/header/ui/header-brand'

import {
  notificationCenterScreenAtom,
  notificationCenterSettingsChangedAtom,
  resetNotificationCenterSettingsAction,
  saveNotificationCenterSettingsAction,
} from '../../atoms'

import { NotificationCenterSettingsBody } from './notification-center-settings-body'

export const NotificationCenterSettings: React.FC = () => {
  const { t } = useTranslation()
  const [_, setScreen] = useAtom(notificationCenterScreenAtom)
  const [changed] = useAtom(notificationCenterSettingsChangedAtom)
  const save = useAction(saveNotificationCenterSettingsAction)
  const reset = useAction(resetNotificationCenterSettingsAction)

  const handleClose = () => {
    reset()
    setScreen('view')
  }
  const handleSave = () => {
    save()
    setScreen('view')
  }

  return (
    <Root>
      <Header>
        <HeaderBrand />
        <CloseButton variant="soft" size="xxs" onClick={handleClose}>
          <Close3Icon size={12} />
        </CloseButton>
      </Header>
      <FadeOverflowContainer variant="vertical">
        <NotificationCenterSettingsBody />
      </FadeOverflowContainer>
      <SaveWrap
        animate={{
          opacity: changed ? 1 : 0.55,
          scale: changed ? 1 : 0.98,
        }}
        transition={{ type: 'spring', stiffness: 420, damping: 30 }}
      >
        <Button
          variant="solid"
          color="primary"
          size="s"
          radius="rounded"
          disabled={!changed}
          onClick={handleSave}
        >
          {t('notification-center.save_changes')}
        </Button>
      </SaveWrap>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 10px;
  padding: 12px;
  background: var(--background-1);
  height: 100%;

  align-items: start;
  align-content: start;

  grid-template-rows: auto 1fr auto;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  justify-content: start;
  justify-items: start;

  gap: 8px;
`

const CloseButton = styled(Button)`
  background: var(--backgroundA-1);

  height: 30px;
  width: 30px;
  padding: 0;

  svg {
    color: var(--text-10);
  }
`

const FadeOverflowContainer = styled(FadeOverflow)`
  overflow: auto;
  min-height: 0;
  align-self: stretch;
`

const SaveWrap = styled(motion.div)`
  display: grid;
`
